import { SMART_LEAD_CAMPAIGN_ANALYTICS_URL } from '@aibees/elephant/constants/integration';
import { ExportVisibility } from '@aibees/elephant/hooks';
import { LockIcon, TextEllipsis } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Avatar, Box } from '@mui/material';
import { memo, useMemo } from 'react';
import { Link } from 'react-router-dom';
import * as Styled from './styles';
import * as SX from './sx';
import type { ExportTableNameProps as Props } from './types';

export const ExportTableName = memo(({ className, item }: Props) => {
  const isPrivate = useMemo(
    () => item.visibility === ExportVisibility.PRIVATE,
    [item.visibility]
  );
  return (
    <Styled.Wrapper
      className={classnames('ExportTableName', className)}
      sx={SX.root}
    >
      <TextEllipsis
        value={item.name}
        variant="body4"
        fontWeight={500}
        color="grey.800"
      />
      <Box display="flex" alignItems="center" flexDirection="row" gap={0.5}>
        {isPrivate && <LockIcon />}

        {item.integrations && (
          <Link
            to={SMART_LEAD_CAMPAIGN_ANALYTICS_URL.replace(
              ':id',
              item.integrations.SMART_LEAD?.id ?? ''
            )}
            target="_blank"
          >
            <Avatar src="/assets/images/Smartlead.jpg" size={16} />
          </Link>
        )}
      </Box>
    </Styled.Wrapper>
  );
});

ExportTableName.displayName = 'ExportTableName';
